import React from "react";
import {
    Modal,
    Container,
    Box,
    Typography,
    Button,
    ThemeProvider,
    createTheme,
} from "@mui/material";
import MessageModal from "./MessageModal";
import Input from "@mui/material/Input";
import { URL, origin } from "../config";
export default function UploadImage(props) {
    const style = {
        backgroundColor: "whitesmoke",
        top: "50%",
        left: "50%",
        position: "absolute",
        transform: "translate(-50%, -50%)",
        width: "60%",
        boxShadow: 24,
        borderRadius: 2,
        minHeight: "30%",
    };

    const theme = createTheme({
        secondary: "#EEEEEE",
        typography: {
            fontFamily: ["Tilt Warp", "sans-serif"].join(","),
        },
    });

    const inputRef = React.useRef(null);
    const [error, setError] = React.useState("");
    const [alert, setAlert] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState("");
    const [file, setFile] = React.useState([]);

    function fileToDataUrl(file) {
        return new Promise((resolve, reject) => {
            const validFileTypes = ["image/jpeg", "image/png", "image/jpg"];
            const valid = validFileTypes.find((type) => type === file.type);
            // Bad data, let's walk away.
            if (!valid) {
                reject("provided file is not a png, jpg or jpeg image.");
            }

            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }

    const handleSubmit = () => {
        const upload = file[0];
        fileToDataUrl(upload, setError)
            .then((fileUrl) => {
                const data = {
                    imageb64: fileUrl,
                };
                fetch(`${URL}/update/image`, {
                    method: "POST",
                    mode: "cors",
                    credentials: "include",
                    headers: {
                        "content-type": `application/json`,
                        Origin: `${origin}`,
                    },
                    body: JSON.stringify(data),
                })
                    .then((response) => {
                        return response.json();
                    })
                    .then((data) => {
                        if (data.error) {
                            setError(data.error.message);
                            throw new Error(data.error.message);
                        }
                    })
                    .catch((err) => console.error(err));
            })
            .then(() => {
                setAlert(true);
                setAlertMessage("updated picture");
            })
            .catch((e) => {
                setError(e);
                console.log(file);
                console.log(inputRef.current.value);
            });
        setFile([]);
        inputRef.current.value = null;
    };

    const handleDelete = () => {
        fetch(`http://localhost:5001/remove/image`, {
            method: "DELETE",
            mode: "cors",
            credentials: "include",
            headers: {
                "content-type": `application/json`,
                Origin: `http://localhost:3000`,
            },
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    setError(data.error.message);
                    throw new Error(data.error.message);
                }
            })
            .then(() => {
                setAlert(true);
                setAlertMessage("profile picture deleted");
            })
            .catch((err) => {
                console.error(err);
            });
    };

    const handleFileChange = (e) => {
        setFile([...file, e.target.files[0]]);
        console.log(file);
        console.log(file.length);
    };

    const closeAlert = () => {
        setAlert(false);
        setAlertMessage("");
    };

    const closeError = () => {
        setError("");
    };
    return (
        <>
            <ThemeProvider theme={theme}>
                <Modal open={props.open} onClose={props.onClose}>
                    <Container sx={{ display: "flex" }}>
                        <Box sx={style} display="flex" flexDirection="row">
                            <Box
                                sx={{
                                    backgroundColor: "#EEEEEE",
                                    borderRadius: "8px 0 0 8px",
                                }}
                                minWidth="60%"
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                            >
                                <Typography variant="h6" textAlign="center">
                                    Edit profile picture
                                </Typography>
                                <Box color="#5d5c5b" sx={{ m: 1, p: 3 }}>
                                    <Typography
                                        fontWeight="bold"
                                        variant="body1"
                                    >
                                        Upload or delete your profile picture
                                    </Typography>
                                    <Typography variant="body1">
                                        - Should be a PNG or JPEG file
                                    </Typography>
                                </Box>
                            </Box>
                            <Box
                                display="flex"
                                flexDirection="column"
                                minWidth="40%"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <Input
                                    inputRef={inputRef}
                                    error={error ? true : false}
                                    disableUnderline
                                    type="file"
                                    accept="image/png, image/jpeg"
                                    sx={{ m: 1, width: "50%" }}
                                    onChange={handleFileChange}
                                ></Input>
                                <Button
                                    disabled={file.length > 0 ? false : true}
                                    variant="outlined"
                                    sx={{ m: 1, width: "50%" }}
                                    onClick={handleSubmit}
                                >
                                    Upload
                                </Button>
                                {props.delete ? (
                                    <Button
                                        variant="outlined"
                                        sx={{ m: 1, width: "50%" }}
                                        color="error"
                                        onClick={handleDelete}
                                    >
                                        Delete
                                    </Button>
                                ) : (
                                    <></>
                                )}
                            </Box>
                        </Box>
                    </Container>
                </Modal>
                <MessageModal
                    severity="success"
                    title="successs"
                    open={alert}
                    onClose={closeAlert}
                >
                    {alertMessage}
                </MessageModal>
                <MessageModal
                    severity="error"
                    title="error"
                    open={error ? true : false}
                    onClose={closeError}
                >
                    {error}
                </MessageModal>
            </ThemeProvider>
        </>
    );
}
